import { setupFormState } from '@/components/form/tidal-form'
import { TrafficAreaFormValues } from './types'

export const form = setupFormState<TrafficAreaFormValues>({
  id: 'trafficAreaForm',
  initialValues: {
    id: '',
    name: '',
    level: -100,
    firstTimeWindowValue: undefined,
    secondTimeWindowValue: undefined,
    points: [],
  },
})
